import { StyleFunctionProps, useColorMode } from '@chakra-ui/react';
import { useCallback } from 'react';

import { Sizes, SizesStruct } from './types';

// Exports
export const useSimpleColorMode = () => {
  const { colorMode } = useColorMode();
  return useCallback(
    (light: string, dark: string) => (colorMode === 'light' ? light : dark),
    [colorMode],
  );
};

/** Convert numeric rem value to numeric pixel value */
export const remToPx = (rem: number) => rem * 16;

/** Helper to flip between values based on the standard `size` prop */
export function size<Value>({ sm, md, lg }: Record<Sizes, Value>) {
  return (props: StyleFunctionProps) => {
    const parsedSize = SizesStruct.parse(props.size);
    switch (parsedSize) {
      case 'sm': {
        return sm;
      }
      case 'md': {
        return md;
      }
      case 'lg': {
        return lg;
      }
      default: {
        throw Error('Unreacheable');
      }
    }
  };
}
